import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileRecordDto } from '@careapp-group/ng-sdk';
import { SwiperContainer } from 'swiper/element';

export interface MediaLightBoxData {
  media: FileRecordDto[];
  memoId?: string;
  swiperIndex?: number;
}

@Component({
  selector: 'ca-media-lightbox',
  templateUrl: './media-lightbox.component.html',
  styleUrls: ['./media-lightbox.component.scss'],
  standalone: false,
})
export class MediaLightBoxComponent implements AfterViewInit {
  public supportedVideoVariants = ['transcodedMp4'];
  public media: FileRecordDto[];
  public memoId?: string;
  public swiperIndex: number;

  @ViewChild('swiper') swiperRef!: ElementRef<SwiperContainer>;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: MediaLightBoxData,
    private cdRef: ChangeDetectorRef,
  ) {
    this.media = data.media || [];
    this.memoId = data.memoId;
    this.swiperIndex = data.swiperIndex || 0;
  }

  ngAfterViewInit() {
    this.swiperRef.nativeElement.swiper.on('slideChange', (swiper) => {
      this.swiperIndex = swiper.activeIndex;
      this.cdRef.markForCheck();
    });
  }

  changeSlideTo(index: number) {
    this.swiperRef.nativeElement.swiper.slideTo(index);
    this.swiperIndex = index;
  }

  trackBy(index: number, item: FileRecordDto) {
    return item.id || index;
  }
}
